import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from './../services/token.service';
import { Injectable } from '@angular/core';

export namespace Headers {
  export const SKIP_INTERCEPTOR_HEADERS = 'X-Skip-Headers';
}

// Adds the authorization token to all http requests, if it exists.
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private readonly tokenService: TokenService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers = this.buildRequestHeaders(request);
    const modifiedRequest = request.clone({ setHeaders: headers });
    return next.handle(modifiedRequest);
  }

  private buildRequestHeaders(request: HttpRequest<any>) {
    let headers;
    
    // if the 'X-Skip-Headers' header is present, the originator of the call does not
    // want the call to be intercepted.
    if (request.headers.get(Headers.SKIP_INTERCEPTOR_HEADERS)) {
      // Use any headers that have been passed in, minus the fake flag
      headers = request.headers.delete(Headers.SKIP_INTERCEPTOR_HEADERS);
    } else {
      headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        'Pragma': 'no-cache',
        'Expires': '0'
      };
    }

    // And then add the auth token no matter what
    const token = this.tokenService.getToken();
    if (token) {
      const tokenValue = `Bearer ${token.access_token}`;
      headers['Authorization'] = tokenValue;
    }

    return headers;
  }
}
